import { render, staticRenderFns } from "./ipsativeChoiceItem.vue?vue&type=template&id=2afc5453"
import script from "./ipsativeChoiceItem.vue?vue&type=script&lang=js"
export * from "./ipsativeChoiceItem.vue?vue&type=script&lang=js"
import style0 from "./ipsativeChoiceItem.vue?vue&type=style&index=0&id=2afc5453&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports